import { Box, CircularProgress, IconButton, useTheme } from '@material-ui/core';
import { CloseIcon, useNotificationModal } from '@room-match/shared-ui-components';
import ProfileImageAdult from 'components/RegistrationForm/AdultForm/ProfileImageAdult/ProfileImageAdult';
import AddNewMember from 'components/RegistrationForm/MinorForm/AddNewMember/AddNewMember';
import { FormikProps, useFormik } from 'formik';
import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { COLORS } from 'shared/constants/COLORS';
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog'; // Create my Own Styled Dialog to edit the CSS - Jerome
import { RepresentationType } from 'shared/enums/RepresentationType';
import { IAddress } from 'shared/interfaces/IAddress';
import { IGeneralSection } from 'shared/interfaces/IGeneral';
import { ICreateTalentPayload } from 'shared/interfaces/ITalent';
import { IUser } from 'shared/interfaces/IUser';
import { countryStateApiService } from 'shared/services/countryStateApiService';
import { profileService } from 'shared/services/profileService';
import { talentService } from 'shared/services/talentService';
import { uploadService } from 'shared/services/uploadService';
import { getCountry } from 'shared/utils/countryStateMapper';
import { ls } from 'shared/utils/ls';
import { errorResponseToArray } from 'shared/utils/room-shared';
import * as yup from 'yup';
import { SubmitButton } from '../Guardianship.styles';
interface Props {
  open: boolean;
  close: () => void;
  disableProfile: boolean;
}
const { getCountries } = countryStateApiService();
const { updateTalent, createGuardian, createTalent, getMe, getTalentMembers, updateMe } = talentService();
const {
  createProfile,
  setProfilePrimaryImage,
  getProfileMatch,
  createMultipleProfiles,
  setSelectProfileMedia,
  claimGhostedProfile,
} = profileService();
const { uploadMedia } = uploadService();

const AddMember: React.FC<Props> = ({ open, close, disableProfile }) => {
  const theme = useTheme();
  const { mutateAsync: patchTalent } = updateTalent();
  const { data: countriesData } = getCountries();
  const { mutate: _, mutateAsync: bindAsync } = setSelectProfileMedia();
  const { mutateAsync, isLoading } = updateMe();
  const { mutate: createTalentMutate, isLoading: talentCreating } = createTalent();
  const { mutateAsync: mutateAsyncCreateMulitipleProfile, isLoading: isLoadingCreateMultipleProfile } =
    createMultipleProfiles();
  const { mutateAsync: claimAsync, isLoading: claimLoading } = claimGhostedProfile();
  const { mutateAsync: mutateAsyncUploadMedia, isLoading: isLoadingUploadMedia } = uploadMedia();
  const { mutateAsync: mutateAsyncSetPrimaryImage, isLoading: isSetPrimaryImageLoading } = setProfilePrimaryImage();
  const [selectedLocation, setSelectedLocation] = useState<IAddress | null>(null);
  const [val, setVal] = useState<number[] | null>([5, 7]);
  const { getLS, setLS, removeLS } = ls();
  const projectId = getLS('projectId');
  const user: IUser = JSON.parse(getLS('user') || '{}');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');

  const { data: profileMatchData } = getProfileMatch(true, firstName, lastName, projectId);

  const [creating, setCreating] = useState(false);
  const [isMemberMinor, setisMemberMinor] = useState(true);
  const [isForGuardian, setisForGuardian] = useState(false);
  const [representatives, setRepresentatives] = useState<any[]>([]);
  const [activeStep, setActiveStep] = useState(0);
  const queryClient = useQueryClient();

  const [generalInfo, setgeneralInfo] = useState<IGeneralSection>({
    ethnic_appearance_primary: '',
    ethnic_appearance_secondary: '',
    ethnic_appearance_other: '',
    hair_colour: '',
    eye_colour: '',
    hair_length: '',
    tattoo: [],
    piercings: [],
    facial_hair: [],
    physical_attributes: [],
    twin_triplet: [],
  });

  const [uploadedImg, setUploadedImg] = useState<{
    name: string;
    type: string;
    size: string;
    file: Blob | undefined;
    imageAttr: { width: number; height: number };
  } | null>(null);

  const memberInitialValues: ICreateTalentPayload = {
    with_minor_work_permit: false,
    email: '',
    first_name: '',
    last_name: '',
    contact_no: '',
    country_code: '',
    adult_minor: 'minor',
    gender: '',
    birth_date: undefined,
    stage_first_name: '',
    stage_middle_name: '',
    stage_last_name: '',
    identifies_as: '',
    sag_status: 'NON UNION',
    representation_type: RepresentationType.FREELANCE,
    sag_id: '',
    agency_ids: [],
    unions: [],
    work_permit_expired_at: undefined,
    middle_name: '',
    managed_by_minor: false,
    completed_primary_details: true,
  };

  const memberValidationScheme = yup.object({
    email: yup.string().required(),
    first_name: yup.string().required('First name is a required field'),
    last_name: yup.string().required('Last name is a required field'),
    contact_no: yup.string().notRequired().min(14, 'Contact number is not valid'),
    country_code: yup.string().notRequired(),
    adult_minor: yup.string().required(),
    gender: yup.string().required('Gender is a required field'),
    birth_date: yup.string(),
    stage_name: yup.string(),
    identifies_as: yup.string(),
    sag_status: yup.string().required('This is a required field'),
    representation_type: yup.string().required(),
    sag_id: yup.string().required(),
    agency_ids: yup.string(),
    with_minor_work_permit: yup.boolean().notRequired(),
    managed_by_minor: yup.boolean().notRequired(),
    work_permit_expired_at: yup.string().notRequired(),
    middle_name: yup.string().notRequired(),
    unions: yup.array(),
    completed_primary_details: yup.boolean().required(),
  });

  const memberForm: FormikProps<ICreateTalentPayload> = useFormik({
    initialValues: memberInitialValues,
    validationSchema: memberValidationScheme,
    validateOnBlur: true,
    onSubmit: (values) => {},
  });

  const memberValidation = () => {
    if (!generalInfo.ethnic_appearance_primary) return true;
    if (!selectedLocation) return true;
    if (memberForm.values.country_code?.toLowerCase() === 'us' && memberForm.values.unions?.length === 0) return true;
    const divisionSupplied = representatives.some((r) => {
      if (r.attributes.divisions?.length > 0) {
        return r.attributes.selected_divisions ? r.attributes.selected_divisions?.length === 0 : true;
      }
      return false;
    });
    const { first_name, last_name, birth_date, email, stage_first_name, gender, contact_no } = memberForm.values;
    if (memberForm.values.representation_type !== RepresentationType.FREELANCE && !representatives.length) {
      return true;
    }

    if (isMemberMinor) {
      if (memberForm.values.managed_by_minor) {
        //minor checked
        if (first_name && last_name && birth_date && stage_first_name && gender && !divisionSupplied) {
          return false;
        }
      } else {
        //minor unchecked
        if (first_name && last_name && birth_date && stage_first_name && gender && !divisionSupplied) {
          return false;
        }
      }
    } else {
      if (isForGuardian) {
        //create profile for guadian
        if (first_name && stage_first_name && birth_date && gender && !divisionSupplied) {
          return false;
        }
      } else {
        //create adult account
        if (first_name && stage_first_name && birth_date && gender && !divisionSupplied && email && contact_no) {
          return false;
        }
      }
    }

    return true;
  };

  const { handleOpen, isOpen, NotificationModal, handleSetMessage } = useNotificationModal({
    type: 'error',
  });

  const showError = (header: string, message: string, button_text: string) => {
    handleSetMessage(header, message, button_text);
    handleOpen();
  };

  const backToAdding = () => {
    setCreating(false);
    queryClient.invalidateQueries('talent/members');
    setActiveStep(0);

    memberForm.resetForm();
    close();
  };

  const createMinorUnchecked = (medium_id: string) => {
    const agency_ids = representatives.map((r) => r.id);
    const { first_name, last_name, gender, sag_status, representation_type, birth_date, identifies_as, adult_minor } =
      memberForm.values;

    const talentInfo = {
      adult_minor,
      sag_status,
      first_name,
      last_name,
      gender,
      representation_type,
      birth_date,
      medium_id,
      identifies_as,
      agency_ids,
    };

    const cleanTalent = Object.entries({ ...talentInfo, completed_primary_details: true }).reduce(
      (a: any, [k, v]: any) => (v ? ((a[k] = v), a) : a),
      {},
    );

    createTalentMutate(cleanTalent, { onSuccess: () => backToAdding() });
  };

  const createMinorChecked = (medium_id: string) => {
    const agency_ids = representatives.map((r) => r.id);
    const {
      first_name,
      last_name,
      middle_name,
      sag_status,
      representation_type,
      birth_date,
      email,
      contact_no,
      country_code,
      managed_by_minor,
      adult_minor,
      identifies_as,
      stage_first_name,
      stage_last_name,
      stage_middle_name,
      other_phone_numbers,
    } = memberForm.values;

    const talentInfo = {
      email,
      middle_name,
      contact_no,
      managed_by_minor,
      adult_minor,
      sag_status,
      first_name,
      last_name,
      ...(!profileMatchData?.data.length && {
        representation_type,
      }),
      birth_date,
      agency_ids,
      medium_id,
      identifies_as,
      stage_first_name,
      stage_last_name,
      stage_middle_name,
      country_code: profileMatchData
        ? profileMatchData?.data[0]?.country_code.toLocaleLowerCase() === 'au'
          ? 'AU'
          : 'US'
        : country_code,
      country: profileMatchData
        ? profileMatchData?.data[0]?.country_code.toLocaleLowerCase() === 'au'
          ? 'Australia'
          : 'United States'
        : 'United States',
      other_phone_numbers: profileMatchData
        ? profileMatchData?.data[0]?.country_code.toLocaleLowerCase() === 'au'
          ? [
              {
                type: 'primary',
                country_code: 'au',
                number: '',
              },
              {
                type: 'secondary',
                country_code: 'au',
                number: '',
              },
              {
                type: 'other',
                country_code: 'au',
                number: '',
              },
              {
                type: 'other',
                country_code: 'au',
                number: '',
              },
            ]
          : other_phone_numbers
        : other_phone_numbers,
    };

    const cleanTalent = Object.entries({ ...talentInfo, completed_primary_details: true }).reduce(
      (a: any, [k, v]: any) => (v ? ((a[k] = v), a) : a),
      {},
    );

    createTalentMutate(cleanTalent, {
      onSuccess: () => backToAdding(),
      onError: (err: any) => {
        if (err.response.data.errors.email[0] === 'has already been taken') {
          setCreating(false);
          setActiveStep(0);
          memberForm.setErrors({ email: 'Email has already been taken' });
        }
      },
    });
  };

  const handleMakePrimary = (profileId: string, mediaId: string) => {
    const formData = new FormData();
    formData.set('medium_id', mediaId);

    mutateAsyncSetPrimaryImage(
      { profileId, formData },
      {
        onSuccess: () => backToAdding(),
      },
    );
  };

  const bindToProfile = async (profileId: string, medium_id: string) => {
    await bindAsync(
      { profileId, payload: { id: medium_id, sort: 0, tag_list: 'image' } },
      {
        onError: (errors) => {
          if (errors?.response?.data?.errors) {
            const errorResponseArray: any = errorResponseToArray(errors.response.data.errors);
            console.error('error', errorResponseArray.join(','));
          } else {
            console.error('error', 'Something went wrong');
          }
        },
      },
    );
    handleMakePrimary(profileId, medium_id);
  };

  const addRepresentatives = async (medium_id: string) => {
    if (profileMatchData?.data.length) {
      await claimAsync(
        medium_id
          ? { profileId: profileMatchData.data.map((p) => p.profile_id), medium_id }
          : { profileId: profileMatchData.data.map((p) => p.profile_id) },
      );
    }

    if (representatives.length) {
      const profilesArr: any = [];

      //filter representatives that has division if profileMatchData is not empty
      const filteredRepresentatives = representatives.filter((r) => {
        if (profileMatchData?.data.length) {
          return (
            r.attributes.divisions?.length &&
            r.attributes.selected_divisions?.length > 0 &&
            r.attributes.selected_divisions[0] !== 'any'
          );
        }
        return true;
      });

      filteredRepresentatives.map((r) => {
        // profilesArr.push({ agency_id: r.id as string, representation_type: 'Agency Representation' });
        profilesArr.push({
          agency_id: r.id as string,
          representation_type: 'Agency Representation',
          ...(r.attributes.divisions.length > 0 &&
            r.attributes.selected_divisions[0] !== 'any' && {
              division_ids: r.attributes.selected_divisions,
            }),
        });
      });

      if (profilesArr.length === 0) {
        return backToAdding();
      }

      mutateAsyncCreateMulitipleProfile(
        { profiles: [...profilesArr], medium_id },
        {
          onSuccess: () => backToAdding(),
          onError: (error: any) => {
            setCreating(false);
            // showError(
            //   'Registration Failed',
            //   error?.response?.data?.errors?.base[0] || 'Failed to process request',
            //   'OK',
            // );
          },
        },
      );
    } else {
      mutateAsyncCreateMulitipleProfile(
        {
          profiles: [
            {
              representation_type: 'Non-Represented',
            },
          ],
          medium_id,
        },
        { onSuccess: () => backToAdding() },
      );
    }
  };

  const createGuardianProfile = async (medium_id: string) => {
    const memberVal = { ...memberForm.values };
    delete memberVal.email;
    await patchTalent({
      general: generalInfo,
    });
    await mutateAsync(
      {
        ...memberVal,
        medium_id,
        completed_primary_details: true,
        country_code: memberVal.country_code,
        country: getCountry(countriesData, (memberVal.country_code || 'AU').toUpperCase()),
        ...(val ? { age_range_from: val[0], age_range_to: val[1] } : {}),
      },
      {
        onSuccess: async (data) => {
          await queryClient.invalidateQueries(['me']);
          addRepresentatives(medium_id);
        },
        onError(error: any, variables, context) {
          setCreating(false);
          // const errorMessage = error.response.data.errors.base[0];
          // setTimeout(() => {
          //   showError('Registration Failed', `${errorMessage}`, 'OK');
          // }, 100);
        },
      },
    );
  };

  const addGuardianTalent = (medium_id: string) => {
    const guardianCountryCode = user.attributes.country_code || 'AU';

    const talentInfo = {
      ...memberForm.values,
      medium_id,
      general: generalInfo,
      other_phone_numbers: [
        {
          country_code: memberForm.values.country_code || guardianCountryCode,
          number: memberForm.values.contact_no || '',
          type: 'primary',
        },
        {
          country_code: memberForm.values.country_code || guardianCountryCode,
          number: '',
          type: 'secondary',
        },
        {
          country_code: memberForm.values.country_code || guardianCountryCode,
          number: '',
          type: 'other',
        },
        {
          country_code: memberForm.values.country_code || guardianCountryCode,
          number: '',
          type: 'other',
        },
      ],
      ...(selectedLocation?.attributes && {
        city_suburb: selectedLocation?.attributes.city_suburb,
        country_code: selectedLocation?.attributes.country_code,
        state_code: selectedLocation?.attributes.state_code,
        zip_code: selectedLocation?.attributes.zip_code,
      }),
      ...(val ? { age_range_from: val[0], age_range_to: val[1] } : {}),
      country: getCountry(countriesData, (memberForm.values.country_code || guardianCountryCode).toUpperCase() || 'AU'),
      ...(memberForm.values.email ? { email: memberForm.values.email } : { email: '' }),
      ...(representatives.length > 0 && {
        agency_ids: representatives.map((r) => r.id),
        representation_type: RepresentationType.AGENCY_REPRESENTATION,
        agency_divisions: representatives
          .filter((f) => f.attributes?.selected_divisions && f.attributes?.selected_divisions[0] !== 'any')
          .map((r) => ({
            agency_id: r.id,
            division_ids: r.attributes.selected_divisions,
          })),
      }),
    };

    const cleanTalent = Object.entries({ ...talentInfo, completed_primary_details: true }).reduce(
      (a: any, [k, v]: any) => (v ? ((a[k] = v), a) : a),
      {},
    );

    createTalentMutate(cleanTalent, {
      onSuccess: async (user) => {
        if (profileMatchData?.data.length) {
          await claimAsync(
            { profileId: profileMatchData.data.map((p) => p.profile_id), medium_id, user_id: user.data.id },
            {
              onSuccess: () => {
                backToAdding();
              },
            },
          );
        } else {
          backToAdding();
        }
      },
      onError: (err: any) => {
        setCreating(false);

        const errors = err.response?.data?.errors || [];
        const errKeys = Object.keys(errors);
        const message = errKeys
          .map((val: any) => `${val.charAt(0).toUpperCase() + val.slice(1)} ${errors[val]}.`)
          .join(' ');
        showError('Registration Failed', message, 'OK');
      },
    });
  };

  const createGuardianTalent = async (id?: string) => {
    setCreating(true);
    const medium_id = id || memberForm.values.medium_id || '';

    if (isForGuardian) {
      createGuardianProfile(medium_id);
    } else {
      addGuardianTalent(medium_id);
    }
  };

  const createMemberAcccount = async () => {
    if (uploadedImg) {
      if (uploadedImg.file) {
        setCreating(true);
        const formData = new FormData();
        formData.append('attachment', uploadedImg.file);
        formData.append('file_name', uploadedImg.name);
        formData.append('file_width', uploadedImg.imageAttr.width.toString());
        formData.append('file_height', uploadedImg.imageAttr.height.toString());
        formData.append('file_size', uploadedImg.size);
        formData.append('file_type', uploadedImg.type);
        formData.append('media_bin', 'true');
        mutateAsyncUploadMedia(
          { formData },
          {
            onSuccess: async (data) => {
              memberForm.setValues({ ...memberForm.values, medium_id: data.data.id });
              createGuardianTalent(data.data.id);
            },
            onError(error: any) {
              const errorMessage = error?.response?.data?.errors?.base[0];
              // showError(
              //   'Image Upload Failed',
              //   errorMessage
              //     ? `${errorMessage}\n\n Please choose another image and try again.`
              //     : 'Please choose another image and try again.',
              //   'OK',
              // );
              setCreating(false);
            },
          },
        );
      }
    }
  };

  const handleUploadImg = async (
    name: string,
    type: string,
    size: string,
    file?: Blob,
    imageAttr?: { width: number; height: number },
  ) => {
    if (file && imageAttr) {
      setUploadedImg({ name, type, size, file, imageAttr });
    }
  };

  const handleSubmit = () => {
    if (activeStep === 0) {
      setActiveStep(1);
    } else {
      createMemberAcccount();
    }
  };

  const photoUploading = () => {
    if (activeStep === 1) {
      return !uploadedImg;
    } else {
      return false;
    }
  };

  return (
    <StyledDialog open={open} onClose={close} maxWidth={false} aria-labelledby="simple-dialog-title">
      {/* <IconButton style={{ width: 40, height: 40, margin: '20px 20px 0 auto' }} onClick={close}>
        <CloseIcon style={{ height: 16, width: 16 }} />
      </IconButton> */}
      <IconButton style={{ width: 40, height: 40, margin: '20px 20px 0 auto' }} onClick={close}>
        <CloseIcon htmlColor={theme.palette.type === 'dark' ? '#fff' : '#000'} style={{ height: 16, width: 16 }} />
      </IconButton>
      <Box style={{ overflowY: 'auto', width: 550, padding: 20, marginLeft: 10 }}>
        {activeStep === 0 ? (
          <AddNewMember
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
            val={val}
            setVal={setVal}
            setFirstName={setFirstName}
            setLastName={setLastName}
            user={JSON.parse(getLS('user') || '{}')}
            disableProfile={disableProfile}
            isForGuardian={setisForGuardian}
            isMemberMinor={setisMemberMinor}
            form={memberForm}
            setRepresentatives={setRepresentatives}
            representatives={representatives}
            profileMatch={profileMatchData}
            generalInfo={generalInfo}
            setgeneralInfo={setgeneralInfo}
          />
        ) : (
          <ProfileImageAdult onFileSelected={handleUploadImg} />
        )}
      </Box>
      {isOpen && <NotificationModal onClose={() => setActiveStep(0)} />}
      <SubmitButton
        variant="contained"
        color="primary"
        disabled={memberValidation() || photoUploading() || creating}
        style={{ backgroundColor: COLORS.PRIMARY }}
        onClick={handleSubmit}
      >
        {creating ? (
          <CircularProgress color="inherit" style={{ width: 25, height: 25, marginRight: 10 }} />
        ) : activeStep === 0 ? (
          'Continue'
        ) : (
          'Finish'
        )}
      </SubmitButton>
    </StyledDialog>
  );
};

export default AddMember;
